import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, CardContent, Card } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import { OrderDetails } from "../types/types";
import Grid from '@mui/material/Grid';


export const OrderItemsAccordion = ({ items }: { items: OrderDetails['items'] }) => {
  const theme = useTheme();
  
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Items</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {items && items.length > 0 ? (
                items.map((item) => (
                  <Grid size={{xs: 12}} key={item.id}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      borderRadius={2}
                      p={1}
                      bgcolor={theme.palette.background.default}
                    >
                      <Typography>
                        {item.product_name} {item.variant_name && `(${item.variant_name})`}
                      </Typography>
                      <Typography>
                        {item.quantity} x ${item.price.toFixed(2)} = $
                        {(item.quantity * item.price).toFixed(2)}
                      </Typography>
                    </Box>
                  </Grid>
                ))
              ) : (
                <Typography>No items found</Typography>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </CardContent>
    </Card>
  );
};